// source: pbtypes/gen/scan_planner/trajectory_action_planner_stop_at_waypoint_reason.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason', null, global);
goog.exportSymbol('proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason.displayName = 'proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason}
 */
proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason;
  return proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason}
 */
proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.scan_planner.TrajectoryActionPlannerStopAtWaypointReason.Enum = {
  INVALID: 0,
  STUCK: 1,
  LARGE_HEADING_CHANGE: 2,
  LOW_WAYPOINT_SPEED: 3,
  TRAJECTORY_DEFLECTION: 4,
  VEHICLE_BODY_VISIBLE: 5,
  ISP_NOT_READY: 6,
  PREV_PHOTO_STILL_ENQUEUED: 7,
  SHORT_DISTANCE_FROM_PREV_WAYPOINT: 8,
  GIMBAL_FLIP: 9,
  FIRST_WAYPOINT: 10,
  USER_REQUESTED: 11
};

goog.object.extend(exports, proto.scan_planner);
